import React from 'react';
import { CSpinner } from '@coreui/react-pro';

const CenterSpinner = ({ size, classNameWrap, className }) => {
     return (
          <div className={`text-center${classNameWrap ? ` ${classNameWrap}` : ''}`}>
               <CSpinner color="primary" size={size} className={className} />
          </div>
     );
};

export default CenterSpinner;
